var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrowseCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M9.007 8.58H7.679V5.95h1.328m0 5.259H7.679V9.894h1.328m-6.569 3.287h11.81c.441 0 .8-.358.8-.8 0-.142-.038-.281-.11-.404L9.034 1.873c-.223-.382-.713-.51-1.095-.287-.118.07-.217.168-.287.287L1.748 11.977c-.223.382-.095.872.287 1.095.122.071.261.11.403.11z",
    transform: "translate(.775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16.15V16H0z",
    transform: "translate(.775)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseCopy);
export default __webpack_public_path__ + "static/media/browse-copy.d0c2abfefc14f4ce04b7775032119f23.svg";
export { ForwardRef as ReactComponent };